import styled from 'styled-components';
const PaginationStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .commentBox {
    display: flex;
    .page-size {
      background-color: #fff;
      .select {
        height: 32px;
      }
      .notranslate {
        display: none;
      }
      /* .MuiSelect-iconOutlined {
        
      } */
    }

    margin-top: 0;
    .pagination {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;

      .previous {
        a {
          width: 23px;
          height: 23px;
        }
        .icon-left {
          width: 20px;
          height: 20px;
          color: #d8d8d8;
        }
      }

      .next {
        a {
          width: 23px;
          height: 23px !important;
        }
        .icon-right {
          width: 20px;
          height: 20px;
          color: #d8d8d8;
        }
      }

      li {
        list-style: none;
        padding: 0 4px;
        min-width: 32px;
        height: 32px;
        text-align: center;
        display: flex;
        align-items: center;
        line-height: 32px;
        margin: 0 8px 4px 0;
        border: 1px solid #9e9e9e;
        border-radius: 4px;
        a {
          display: flex;
          width: 100%;
          height: 100%;
          font-size: 14px;
          justify-content: center;
          align-content: center;
          /* letter-spacing: 0; */
          color: #212121;
        }
      }
      .active {
        /* border-radius: 50%; */
        border-color: ${(props) => props.theme.palette.primary.main};
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        a {
          color: ${(props) => props.theme.palette.primary.main};
        }
      }
      .previous {
        a {
          display: flex;
          align-items: center;
        }
        a:active {
          color: red;
        }
      }
      .next {
        a {
          display: flex;
          align-items: center;
        }
        a:hover {
          color: red;
        }
      }
    }
  }
`;
export default PaginationStyled;
